import { createUseStyles } from 'react-jss';

const styles = {
  inputLine: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    marginBottom: '0.5rem',
    justifyContent: 'space-between'
  },
  comboBox: {
    flex: 'auto',
    marginLeft: '0.5rem'
  },
  marginLeft: {
    marginLeft: '0.5rem'
  },
  languageColumn: {
    width: '8rem',
    minWidth: '6rem'
  },
  draft: {
    color: 'gray'
  },
  pending: {
    color: '#FBBE42'
  },
  completed: {
    color: '#26A65B'
  },
  resetEdit: {
    color: '#0A6ED1'
  },
  resetNotEdit: {
    color: '#A6A6A6'
  }
};

export const useStyles = createUseStyles(styles, {
  name: 'DistributionPanel'
});
